// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"efad33f7","150":"6e47014c","407":"ff0f4d6e","703":"1c445189","705":"d12116a8"}[chunkId] + ".chunk.js";
};